module.exports = __webpack_public_path__ + "fonts/righthand-light-personal.9911cded.ttf";